export default __webpack_public_path__ + "static/media/user-placeholder.407cc2b1.svg";